import React, { useEffect, useState } from "react";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import PatternService from "Services/http/endpoints/pattern/PatternService";
import { read } from "Helpers/LocalStorage";
import { useSetState } from "Helpers/Hooks";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import StatusHandler from "Helpers/StatusHandler";
import { useSelector } from "react-redux";
import MuiButton from "Components/MuiButton/MuiButton";
import showNotify from "Helpers/Notify";
import { useTranslation } from "react-i18next";

function PartsRightClick({ data, onChangeData, completePanel }) {
  const { t } = useTranslation();
  const { selectedUser } = useSelector((state) => ({
    selectedUser: state.project.selectedUser,
  }));
  const [loading, setLoading] = useState(false);
  const [controls, setControls] = useSetState({
    panel: {
      type: "select",
      selectItems: [],
      value: "",
    },
    glazing: {
      type: "select",
      selectItems: [],
      value: "",
    },
    glassGroup: {
      type: "select",
      selectItems: [],
      value: "",
    },
    glassName: {
      type: "select",
      selectItems: [],
      value: "",
    },
    net: {
      type: "select",
      selectItems: [],
      value: "",
    },
    brand: {
      type: "select",
      selectItems: [],
      value: "",
    },
    pop: {
      type: "select",
      selectItems: [],
      value: "",
    },
  });

  const onCompletePanel = () => {
    completePanel();
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });

    if (controlName === "glassGroup") {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdGroupProduct: value.value,
          UserSelect: 0,
          KeyRequestUser: selectedUser?.Key,
        };
        const response = await PatternService.getGlass(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const list = response.data.Value;
          const itemsGlass = list.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          setControls({ glassName: { selectItems: itemsGlass } });
          setControls({ glassName: { value: itemsGlass[0] } });
          if (controls.glassName.value?.Wall !== itemsGlass[0].value?.Wall) {
            showNotify({
              text: t('glassWallError'),
              customClass: "warning",
            });
          }
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (controlName === "brand") {
      const paramsPop = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdBrandFitting: value.value,
        IdPop: data.Id_type_pop_fitting,
        KeyRequestUser: selectedUser?.Key,
      };
      const responsePop = await DrawerService.getPopDesign(paramsPop);
      let err = StatusHandler(responsePop);
      if (!err.isFail) {
        const projectList = responsePop.data.Value;
        const items = projectList.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        setControls({ pop: { value: items[0] } });
        setControls({ pop: { selectItems: items } });
      }
    }
    if (controlName === "glassName") {
      if (value?.Wall !== controls.glazing.value?.Wall) {
        showNotify({
          text: t('glassWallError'),
          customClass: "warning",
        });
      }
    }
    if (controlName === "glazing") {
      if (controls.glassName.value?.Wall !== value?.Wall) {
        showNotify({
          text: t('glassWallError'),
          customClass: "warning",
        });
      }
    }
  };

  useEffect(() => {
    (async () => {
      try {
        if (data.Id_panel !== 0) {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdProduct: data.Id_panel,
            All: true,
            UserSelect: 0,
            KeyRequestUser: selectedUser?.Key,
          };
          const response = await DrawerService.getListProfileRight(params);
          let err = StatusHandler(response);
          if (!err.isFail) {
            const projectList = response.data.Value;
            const items = projectList.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const selectedItem = items.find(
              (item) => item.Id === data.Id_panel
            );
            setControls({ panel: { value: selectedItem } });
            setControls({ panel: { selectItems: items } });
          }
        }
        if (data.Id_glazing) {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdProduct: data.Id_glazing,
            All: true,
            UserSelect: 0,
            IsGlazing: true,
            KeyRequestUser: selectedUser?.Key,
          };
          const response = await DrawerService.getListProfileRight(params);
          let e = StatusHandler(response);
          if (!e.isFail) {
            const list = response.data.Value;
            const items = list.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const selectedItem = items.find(
              (item) => item.Id === data.Id_glazing
            );
            setControls({ glazing: { value: selectedItem } });
            setControls({ glazing: { selectItems: items } });
          }
        }
        if (data.Id_glass) {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id_glass,
          };
          const response = await DrawerService.getGlassDesign(params);
          let err = StatusHandler(response);
          if (!err.isFail) {
            const list = response.data.Value;
            const itemsGlass = list.GlassList.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const itemsGroup = list.GroupList.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const selectedItem = itemsGlass.find(
              (item) => item.Id === data.Id_glass
            );
            setControls({ glassName: { value: selectedItem } });
            setControls({ glassGroup: { selectItems: itemsGroup } });
            setControls({
              glassGroup: {
                value: { value: list.Group, label: list.GroupName },
              },
            });
            setControls({ glassName: { selectItems: itemsGlass } });
          }
        }
        if (data?.Id_net) {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            KeyRequestUser: selectedUser?.Key,
          };
          const response = await PatternService.getTori(params);
          let err = StatusHandler(response);
          if (!err.isFail) {
            const projectList = response.data.Value;
            const items = projectList.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const selectedItem = items.find((item) => item.Id === data.Id_net);
            setControls({ net: { value: selectedItem } });
            setControls({ net: { selectItems: items } });
          }
        }
        if (data?.Id_brand_fitting !== 0 && data?.Id_type_pop_fitting !== 0) {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdPop: data.Id_type_pop_fitting,
            KeyRequestUser: selectedUser?.Key,
          };
          const response = await DrawerService.getBrandFitting(params);
          let e = StatusHandler(response);
          if (!e.isFail) {
            const projectList = response.data.Value;
            const items = projectList.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const selectedItem = items.find(
              (item) => item.Id === data.Id_brand_fitting
            );
            setControls({ brand: { value: selectedItem } });
            setControls({ brand: { selectItems: items } });
          }
          const paramsPop = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdBrandFitting: data.Id_brand_fitting,
            IdPop: data.Id_type_pop_fitting,
            KeyRequestUser: selectedUser?.Key,
          };
          const responsePop = await DrawerService.getPopDesign(paramsPop);
          let err = StatusHandler(responsePop);
          if (!err.isFail) {
            const projectList = responsePop.data.Value;
            const items = projectList.map((m) => {
              return {
                ...m,
                value: m.Id,
                label: m.Name,
              };
            });
            const selectedItem = items.find(
              (item) => item.Id === data.Id_type_pop_fitting
            );
            setControls({ pop: { value: selectedItem } });
            setControls({ pop: { selectItems: items } });
          }
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    })();
  }, []);

  useEffect(() => {
    onChangeData(controls);
  }, [controls]);

  return (
    <Grid container spacing={2}>
      {
        data.Id_glazing !== 0 &&
        <Grid item xs={12}>
          <MuiAutoComplete
            autoSelect={true}
            options={controls.glazing.selectItems}
            label={<Translator id={"glazing"} />}
            value={controls.glazing.value}
            id={"glazing"}
            onChange={autoCompleteHandler}
          />
        </Grid>
      }
      {
        data.Id_net !== 0 &&
        <Grid item xs={12}>
          <MuiAutoComplete
            autoSelect={true}
            options={controls.net.selectItems}
            label={<Translator id={"net"} />}
            value={controls.net.value}
            id={"net"}
            onChange={autoCompleteHandler}
          />
        </Grid>
      }
      {
        data.Id_glass !== 0 &&
        <>
          <Grid item xs={12}>
            <MuiAutoComplete
              autoSelect={true}
              options={controls.glassGroup.selectItems}
              label={<Translator id={"glassGroup"} />}
              value={controls.glassGroup.value}
              id={"glassGroup"}
              onChange={autoCompleteHandler}
            />
          </Grid>
          <Grid item xs={12}>
            <MuiAutoComplete
              autoSelect={true}
              options={controls.glassName.selectItems}
              label={<Translator id={"glassName"} />}
              value={controls.glassName.value}
              id={"glassName"}
              onChange={autoCompleteHandler}
            />
          </Grid>
        </>
      }
      {
        (data?.Id_brand_fitting !== 0 && data?.Id_type_pop_fitting !== 0) &&
        <>
          <Grid item xs={12}>
            <MuiAutoComplete
              autoSelect={true}
              options={controls.brand.selectItems}
              label={<Translator id={"brand"} />}
              value={controls.brand.value}
              id={"brand"}
              onChange={autoCompleteHandler}
            />
          </Grid>
          <Grid item xs={12}>
            <MuiAutoComplete
              autoSelect={true}
              options={controls.pop.selectItems}
              label={<Translator id={"pop"} />}
              value={controls.pop.value}
              id={"pop"}
              onChange={autoCompleteHandler}
            />
          </Grid>
        </>
      }
      {
        data.Id_panel !== 0 &&
        <>
          <Grid item sm={8} xs={12}>
            <MuiAutoComplete
              autoSelect={true}
              options={controls.panel.selectItems}
              label={<Translator id={"panel"} />}
              value={controls.panel.value}
              id={"panel"}
              onChange={autoCompleteHandler}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <MuiButton
              loading={loading}
              variant="contained"
              color="primary"
              onClick={onCompletePanel}
              title={t('panelCompletion')}
              fullwidthOnSm
            />
          </Grid>
        </>
      }
    </Grid>
  );
}

export default PartsRightClick;
